import angular from 'angular';
import { TrabalhadoresService } from './trabalhadores.service';
import { ListagemService } from '../../shared/services/listagem.service';

export const TrabalhadoresListRouting = [
    '$stateProvider',
    function ($stateProvider: angular.ui.IStateProvider) {
        const buildListParams = (tipo: string, status: string = '00') => ({
            tipo,
            status,
            returnContext: null
        });

        const resolve = {
            'entity': [
                'TrabalhadoresService',
                'ListagemService',
                '$rootScope',
                '$stateParams',
                '$state',
                '$q',
                function(
                    entityService: TrabalhadoresService,
                    listagemService: ListagemService,
                    $rootScope: angular.IRootScopeService & {
                        session: any,
                        liberadoTela: (arg: string) => boolean
                    },
                    $stateParams: angular.ui.IStateParamsService,
                    $state: angular.ui.IStateService,
                    $q: angular.IQService
                ) {
                    if (!$stateParams['trabalhador']) {
                        return $q<void>(() => $state.go('trabalhadores'));
                    }

                    return entityService.get($stateParams['trabalhador'])
                        .then((data) => {
                            const visibilidadeLiberada = $rootScope.liberadoTela('LIBERAR_REFATORACAO_VISIBILIDADE');
                            const empresaNoGrupo = listagemService.getEmpresa(data.empresa.empresa);
                            const mesmoEstabelecimento = data.estabelecimento.estabelecimento === $rootScope.session.entities.estabelecimento.estabelecimento;

                            const deveRedirecionar = (
                                (visibilidadeLiberada && !empresaNoGrupo) ||
                                (!visibilidadeLiberada && !mesmoEstabelecimento)
                            );

                            if (deveRedirecionar) {
                                return $q(() => $state.go('trabalhadores'));
                            }

                            return data;
                        })
                        .catch((error) => {
                            if (error.status === 404) {
                                return $q(() => {
                                    if ($state.href('trabalhadores_not_found', $stateParams)) {
                                        $state.go('trabalhadores_not_found', $stateParams);
                                    } else {
                                        $state.go('not_found', $stateParams);
                                    }
                                });
                            }

                            return $q.reject(error);
                        });
                }
            ]
        };

        $stateProvider
            .state('trabalhadores', {
                url: '/colaboradores',
                params: buildListParams('-1'),
                template: require('html-loader!./index/trabalhadores.index.html'),
                controller: 'TrabalhadoresListController',
                controllerAs: 'trblhdrs_lst_cntrllr',
                reloadOnSearch: false
            })
            .state('trabalhadores_funcionarios', {
                url: '/colaboradores',
                params: buildListParams('0'),
                template: require('html-loader!./index/trabalhadores.index.html'),
                controller: 'TrabalhadoresListController',
                controllerAs: 'trblhdrs_lst_cntrllr',
                reloadOnSearch: false
            })
            .state('trabalhadores_contribuintes', {
                url: '/colaboradores',
                params: buildListParams('1'),
                template: require('html-loader!./index/trabalhadores.index.html'),
                controller: 'TrabalhadoresListController',
                controllerAs: 'trblhdrs_lst_cntrllr',
                reloadOnSearch: false
            })
            .state('trabalhadores_estagiarios', {
                url: '/colaboradores',
                params: buildListParams('2'),
                template: require('html-loader!./index/trabalhadores.index.html'),
                controller: 'TrabalhadoresListController',
                controllerAs: 'trblhdrs_lst_cntrllr',
                reloadOnSearch: false
            })
            .state('trabalhadores_show', {
                url: '/colaboradores/:trabalhador?tab',
                params: {
                    returnState: null,
                    returnContext: null
                },
                resolve,
                template: require('html-loader!./show.html'),
                controller: 'TrabalhadoresFormController',
                controllerAs: 'trblhdrs_frm_cntrllr'
            });
    }
];
